import React from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import { IEmailTemplateField } from '../../../../api/email-templates.dao';
import Text from '../../../global/text/text';
import { editText } from '../../../../constants/common-labels.constants';
import DefaultButton from '../../../global/default-button/default-button';

export interface IEmailTemplatesListItemProps {
    template: IEmailTemplateField;
    openEditBlueprintForm: (emailTemplateId: string) => void;
    editEmailTemplatePermission: boolean;
    isSelected: boolean;
}

const EmailTemplatesListItem = ({
    template,
    openEditBlueprintForm,
    editEmailTemplatePermission,
    isSelected,
}: IEmailTemplatesListItemProps) => {

    const onDoubleClickHandler = () => {
        if (editEmailTemplatePermission) openEditBlueprintForm(template.id);
    };

    const cellEffectClasses = classnames({
        'active': isSelected,
        'hoverable': !isSelected,
    });

    return (
        <tr onDoubleClick={onDoubleClickHandler} >
            <Text className={cellEffectClasses} withEllipsis message={template.name} tag='td'/>
            <Text className={cellEffectClasses} withEllipsis message={template.description} tag='td'/>
            <Text className={cellEffectClasses} textTitle={template.to.join('\n')} withEllipsis message={template.to.join(', ')} tag='td'/>
            <Text className={cellEffectClasses} textTitle={template.replyTo.join('\n')} withEllipsis message={template.replyTo.join(', ')} tag='td'/>
            <td className={`align-right ${cellEffectClasses}`} >
                {editEmailTemplatePermission && <DefaultButton
                    text={editText()}
                    modifier='slim'
                    onClick={() => openEditBlueprintForm(template.id)}
                    className='visible-while-hovered edit-template'
                />}
            </td>
        </tr>
    );
};

export default observer(EmailTemplatesListItem);
